import { Injectable } from '@angular/core';
import { NgModel } from '@angular/forms';
import { RoadTypesService } from "../routes/admin/routes/roads/services/road-types.service";

@Injectable({
  providedIn: 'root'
})

export class SelectService {

    public items_length: number = 1;
    public all: boolean = false;
    public selected_name: string;
    public selectedData: any = [];
    public dataSel: string;
    constructor(public roadTypesService: RoadTypesService) {
    }

   /**
    * Switch ng-select select all options
    * @param data an array of objects that we should select, like <[{name: "События скорости", code: 1},...]>.
    * @param select ngModel: directive that two-way data binding for <ng-select>.
    * @param bind_value just that the property is related with ng-select, like <bindValue="code">.
    * @param ng_model array of bounded values, like <[1, 0, 2, 3]>.
   */
    toggleSelectAll(data: any, select: NgModel, bind_value: any,  ng_model: any) {
       this.items_length = 0;
       if (data.length > ng_model.length) {
          this.onSelectAll(data, select, bind_value);
       } else {
          this.onClearAll(select);
       }
         this.all = !this.all;
    }

   /**
    * Select all options.
    * @param data
    * @param select
    * @param bind_value
    */
    public onSelectAll(data, select: NgModel, bind_value?: any) {
       const selected = data.map(item => item[bind_value]);
       this.items_length = data.length == selected.length ? selected.length : 0;
       select.update.emit(selected);
    }

   /**
    * Deselect all selected options.
    * @param select
    */
    public onClearAll(select: NgModel) {
       select.update.emit([]);
    }
}
